<template>
  <div class="container-fluid content__instructions py-4 px-5">
    <div class="row">
      <div class="col-12">
        <div class="col-12 mb-3 text-center pt-3 pb-3">
          <h1>ADMINISTRADOR DE BANNERS DEL SLIDER</h1>
        </div>
        <h4 class="title">Consideraciones:</h4>
        <ul>
          <li>Las dimensiones de las imágenes o videos deberán ser de <b>1920x726.</b></li>
          <li>El peso de las imágenes no deberá exceder de <b>1mb.</b></li>
          <li>El peso de los videos no deberá exceder de <b>5mb.</b></li>
          <li>
            El nombre de la imagen o video <b>no debe contener espacios (utilizar _ o - en
            su lugar) ni caracteres especiales</b>.
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Instructions",
};
</script>
<style scoped>
h4.title {
  font-weight: 700;
  text-transform: uppercase;
}
.content__instructions {
  background: white;
}
h1 {
  font-size: 24px;
  font-weight: 700;
}

@media (max-width:700px) {
    h1{
        font-size: 20px;
    }
    h4{
      font-size: 17px;
    }
    li{
      font-size: 14px;
    }
}


</style>